/**
 * Implements Trades Saga
 * Main idea is to fetch trades each time new block mined for ETH
 */
import { ITrendingItem } from '@kattana-io/common';
import { takeLatest, put, call } from 'redux-saga/effects';

import { actionSetTrending, GET_TRENDING } from '../actions/trending';
import { KattanaAPI } from '../store/createStore';


function* onGetTrending(): any {
  const controller = new AbortController();
  const data: ITrendingItem[] | null = yield call(KattanaAPI.trending, controller);
  if (data) {
    yield put(actionSetTrending({
      items: data,
      isError: false
    }));
    return;
  }
  yield put(actionSetTrending({
    items: [],
    isError: true
  }));
}

export default function* ratesSaga() {
  yield takeLatest(GET_TRENDING, onGetTrending);
}
